import React from 'react';
import { Link } from 'react-router-dom';
import './Sections.css';

const Section6 = () => {
  const testimonials = [
    {
      quote: "Fridays used to take hours sorting payments. Now I can pay 30 guys in a couple of clicks — plus they all get notified by email straight away. Absolute game-changer for our business.",
      name: "Richard Harrison",
      company: "Insides Interiors Ltd"
    },
    {
      quote: "Online timesheets, onboarding and contracts for new subcontractors sorted automatically. Total game changer. We've saved at least 8 hours a week on admin.",
      name: "James Camm",
      company: "CO2UK Limited"
    }
  ];

  return (
    <section className="section-6">
      <div className="paycis-container">
        <h2 className="section-6-headline">
          What our customers say:
        </h2>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <p className="testimonial-quote">"{testimonial.quote}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.company}</span>
              </div>
            </div>
          ))}
        </div>
        
        <div className="final-cta">
          <h3 className="final-cta-text">
            Sign up and invite your subs, it's as simple as that:
          </h3>
          <Link to="/register" className="cta-large">
            GET STARTED
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Section6;